import React from 'react';

export default function SummaryCards({ data }) {
  if (!data) return null;

  return (
    <div className="summary-row">
      <div className="summary-card green animate-in stagger-1">
        <div className="label">אתרים תקינים</div>
        <div className="value">{data.healthy || 0}</div>
        <div className="sub trend-flat">מתוך {data.total_sites}</div>
      </div>
      <div className="summary-card yellow animate-in stagger-2">
        <div className="label">דורשים תשומת לב</div>
        <div className="value">{data.warning || 0}</div>
        <div className="sub trend-flat">&mdash;</div>
      </div>
      <div className="summary-card red animate-in stagger-3">
        <div className="label">בעיות קריטיות</div>
        <div className="value">{data.critical || 0}</div>
        <div className="sub trend-flat">&mdash;</div>
      </div>
      <div className="summary-card blue animate-in stagger-4">
        <div className="label">מיקום ממוצע (פורטפוליו)</div>
        <div className="value">{data.portfolio_avg_position ?? '-'}</div>
        <div className="sub trend-flat">{data.total_keywords} ביטויים</div>
      </div>
      <div className="summary-card purple animate-in stagger-5">
        <div className="label">בעמוד ראשון</div>
        <div className="value">{data.total_top10 || 0}</div>
        <div className="sub trend-flat">TOP 3: {data.total_top3 || 0}</div>
      </div>
    </div>
  );
}
